module.exports = __webpack_public_path__ + "img/rastreabilidade.476291a6.svg";